/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBooleanDecoder,
  getBooleanEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type EntryMigrated = {
  market: Address;
  oracle: Address;
  entryId: ReadonlyUint8Array;
  baseMint: Address;
  contribution: bigint;
  isWinner: boolean;
};

export type EntryMigratedArgs = {
  market: Address;
  oracle: Address;
  entryId: ReadonlyUint8Array;
  baseMint: Address;
  contribution: number | bigint;
  isWinner: boolean;
};

export function getEntryMigratedEncoder(): FixedSizeEncoder<EntryMigratedArgs> {
  return getStructEncoder([
    ['market', getAddressEncoder()],
    ['oracle', getAddressEncoder()],
    ['entryId', fixEncoderSize(getBytesEncoder(), 32)],
    ['baseMint', getAddressEncoder()],
    ['contribution', getU64Encoder()],
    ['isWinner', getBooleanEncoder()],
  ]);
}

export function getEntryMigratedDecoder(): FixedSizeDecoder<EntryMigrated> {
  return getStructDecoder([
    ['market', getAddressDecoder()],
    ['oracle', getAddressDecoder()],
    ['entryId', fixDecoderSize(getBytesDecoder(), 32)],
    ['baseMint', getAddressDecoder()],
    ['contribution', getU64Decoder()],
    ['isWinner', getBooleanDecoder()],
  ]);
}

export function getEntryMigratedCodec(): FixedSizeCodec<
  EntryMigratedArgs,
  EntryMigrated
> {
  return combineCodec(getEntryMigratedEncoder(), getEntryMigratedDecoder());
}
